module.exports = __webpack_public_path__ + "static/media/boy-back-sitting.c6275c13.png";